import React from 'react';

import classNames from 'classnames';
import ReactDOM from 'react-dom';

class RightAddon extends React.Component {
    onClick = () => {
        // eslint-disable-next-line react/no-find-dom-node
        const addon = ReactDOM.findDOMNode(this.addon);
        const input = addon.parentNode.querySelector('input');
        if (input) {
            input.focus();
        }
    };

    render() {
        const { content, className } = this.props;
        return (
            <div
                ref={(component) => (this.addon = component)}
                onClick={this.onClick}
                className={classNames(className, 'iw-pure-input-right-addon')}>
                {content}
            </div>
        );
    }
}

export default RightAddon;
